//config.js
module.exports  = {
	baseUrl: 'https://data.dvrc.fr/mel/',
}
